// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DropdownFilters_wrapper__rfxAM","filter":"DropdownFilters_filter__2LZfx","alternatives":"DropdownFilters_alternatives__3tD_d"};